import { of } from "rxjs";
import { inject, makeStateKey, TransferState } from "@angular/core";
import { QuoteModel } from "../models/quote-model";
import { switchMap } from "rxjs/operators";
import { TServiceResult } from "@shared/helper/t-service-result";
import {  ResolveFn } from "@angular/router";

import { QuoteAggrigatorService } from "../services/quote-aggrigator.service";
import { LocalRepository } from "@shared/helper/local-repository";

export const STATE_KEY_QUOTE = makeStateKey<TServiceResult<QuoteModel>>('Quote_Resolver_Data');


export const QuoteDetailResolver: ResolveFn<TServiceResult<QuoteModel>> = (route, state) => {
    const serverState: TransferState = inject(TransferState);
    const _localRepository: LocalRepository = inject(LocalRepository);
    const quoteAggrigatorService: QuoteAggrigatorService = inject(QuoteAggrigatorService);
    if (!_localRepository.IsInBrowser) {
        return quoteAggrigatorService.getById(route.paramMap.get('id')!)
            .pipe(
                switchMap(res => {
                    serverState.set(STATE_KEY_QUOTE, res);
                    return of(res);
                })
            );
    }
    else {
        return of(serverState.get(STATE_KEY_QUOTE, new TServiceResult<QuoteModel>(new QuoteModel(), '', null, true, '')));
    }
}
